import {Loader} from '@orbit-ui/components/loader';
import {TooltipProvider} from '@orbit-ui/components/tooltip';
import {createRootRouteWithContext, Outlet} from '@tanstack/react-router';
import {AuthProvider} from '@/features/auth/context/auth-provider';
import {QueryClientProvider} from '@/features/core/api/query-client';
import {TransportProvider} from '@/features/core/api/transport';
import {AppProvider} from '@/features/core/components/app-provider';
import {DevelopmentTools} from '@/features/development';
import {rootLogger} from '@/features/development/services/root-logger';

export type AppRouteContext = {
  title?: string;
  description?: string;
  breadcrumb?: {
    label: string;
    path: string;
    isDisabled?: boolean;
    isSkipped?: boolean;
  };
  hasNoShell?: boolean;
};

const routeLogger = rootLogger.getChildLogger('route');

export const Route = createRootRouteWithContext<AppRouteContext>()({
  component: () => <RootRoute />,
  pendingComponent: () => <Loader />,
  beforeLoad: (): AppRouteContext => ({
    breadcrumb: undefined,
  }),
});

function RootRoute() {
  routeLogger.debug('/__root');

  return (
    <AppProvider
      components={[
        // Each provider here wraps the next
        AuthProvider,
        TransportProvider,
        QueryClientProvider,
        TooltipProvider,
      ]}
    >
      <Outlet />
      <DevelopmentTools />
    </AppProvider>
  );
}
